export default __webpack_public_path__ + "static/media/xibaluku.c0560ced.jpg";